/**
 * Objets pouvant porter un fil de conversation.
 *
 * Vocabulaire partagé avec le serveur : il est envoyé tel quel dans le `entityType`
 * d'une conversation, et dans le `data` d'une notification push (#173). La liste
 * fait foi côté serveur — cf. `messaging/NOTIFICATION_STRATEGY.md` de `b4cash-srv`.
 */
export enum ConversationEntityTypeEnum {
    BankAccountLine = 'bank_account_line',
    CardReceipt = 'card_receipt',
    CashTransaction = 'cash_transaction',
    Cheque = 'cheque',
    CreditCardTransaction = 'credit_card_transaction',
    Deposit = 'deposit',
    Employee = 'employee',
    PurchaseInvoice = 'purchase_invoice',
    Quotation = 'quotation',
    SalesInvoice = 'sales_invoice',
    Shareholder = 'shareholder',
}
